import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../AuthContext';
import logo from '../logo-gulliver.png';

export default function Login() {
  const { loginConGoogle } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  async function handleSuccess(credentialResponse) {
    try {
      await loginConGoogle(credentialResponse.credential);
      navigate('/');
    } catch (e) {
      // El backend devuelve 403 si el email no es @gulliver.cl, con un
      // mensaje específico en 'detail'. Lo mostramos tal cual.
      if (e?.response?.status === 403 && e?.response?.data?.detail) {
        setError(e.response.data.detail);
      } else {
        setError('No pudimos verificar tu cuenta. Intenta de nuevo.');
      }
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1a1a2e',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2rem',
    }}>
      {/* Logo */}
      <img src={logo} alt="Gulliver" style={{ height: 80, objectFit: 'contain' }} />

      {/* Título */}
      <div style={{ textAlign: 'center' }}>
        <h1 style={{
          color: 'white',
          fontFamily: "'Montserrat', sans-serif",
          fontWeight: 600,
          fontSize: 28,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          marginBottom: 8,
        }}>
          Cuidándonos
        </h1>
        <p style={{ color: '#adb5bd', fontSize: 15 }}>
          Ingresa con tu cuenta de Google para continuar
        </p>
      </div>

      {/* Botón Google */}
      <div style={{
        background: 'white',
        borderRadius: 16,
        padding: '2rem 2.5rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1.25rem',
        minWidth: 320,
      }}>
        <p style={{ color: '#374151', fontSize: 14, fontWeight: 600, margin: 0 }}>
          Acceso para equipos Gulliver
        </p>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => setError('Error al iniciar sesión con Google')}
          text="signin_with"
          shape="rectangular"
          size="large"
          width="260"
          locale="es"
        />
        {error && (
          <p style={{ color: '#e63946', fontSize: 13, margin: 0, textAlign: 'center' }}>
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
